import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { myApi } from '../../../config/axiosConfig'; // Ajusta ruta según tu estructura

const DetalleDialog = ({ open, onClose, unidadId }) => {
  const [datos, setDatos] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    /* { field: 'id', headerName: 'ID', width: 70 }, */
    { field: 'posicion', headerName: 'POSICIÓN', width: 150 },
    { field: 'marca', headerName: 'MARCA', width: 150 },
    { field: 'tipo', headerName: 'TIPO DE MATERIAL', width: 150 },
    // ajusta según tus datos reales
  ];

  useEffect(() => {
    const fetchDetalle = async () => {
      if (!unidadId) return;

      setLoading(true);
      try {
        const response = await myApi.get(`/alta_unidad/getDetalleUnidad?id=${unidadId}`);
        setDatos(response.data.data || []);
      } catch (error) {
        console.error("Error cargando detalles:", error);
        setDatos([]);
      } finally {
        setLoading(false);
      }
    };

    if (open) {
      fetchDetalle();
    }
  }, [unidadId, open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Detalles de Unidad #{unidadId}</DialogTitle>
      <DialogContent>
        <div style={{ height: 300, width: '100%' }}>
          <DataGrid
            rows={datos}
            columns={columns}
            loading={loading}
            getRowId={(row) => row.id || row.campo1}
            disableRowSelectionOnClick
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetalleDialog;
